// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__uH62X","messages":"Chat_messages__22aBS","dateDivider":"Chat_dateDivider__2lwIY"};